import Box from '@mui/material/Box';
import Paper from '@mui/material/Paper';
import Typography from '@mui/material/Typography';
import Avatar from '@mui/material/Avatar';
import Rating from '@mui/material/Rating';
import Chip from '@mui/material/Chip';
import type { Review } from '@/types';

function travelerName(review: Review) {
  const { firstName, lastName } = review.traveler;
  return [firstName, lastName].filter(Boolean).join(' ') || 'Traveler';
}

function formatDate(dateStr: string) {
  return new Date(dateStr).toLocaleDateString('en-IN', {
    day: '2-digit',
    month: 'short',
    year: 'numeric',
  });
}

interface GuideReviewListItemProps {
  review: Review;
}

export function GuideReviewListItem({ review }: GuideReviewListItemProps) {
  return (
    <Paper
      elevation={0}
      sx={{
        p: 2,
        mb: 1.5,
        border: '1px solid',
        borderColor: 'divider',
        borderRadius: 2,
      }}
    >
      <Box sx={{ display: 'flex', gap: 1.5, alignItems: 'flex-start' }}>
        <Avatar src={review.traveler.avatar} sx={{ width: 44, height: 44 }}>
          {travelerName(review)[0]?.toUpperCase()}
        </Avatar>
        <Box sx={{ flex: 1, minWidth: 0 }}>
          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'space-between',
              gap: 1,
              flexWrap: 'wrap',
              mb: 0.5,
            }}
          >
            <Typography variant="subtitle2" fontWeight={700}>
              {travelerName(review)}
            </Typography>
            <Typography variant="caption" color="text.secondary">
              {formatDate(review.createdAt)}
            </Typography>
          </Box>
          <Rating value={review.rating} readOnly size="small" sx={{ mb: 0.5 }} />
          {review.destination?.name && (
            <Chip label={review.destination.name} size="small" variant="outlined" sx={{ mb: 1 }} />
          )}
          <Typography variant="body2" color="text.secondary" sx={{ lineHeight: 1.7 }}>
            {review.comment}
          </Typography>
        </Box>
      </Box>
    </Paper>
  );
}
